module.exports = __webpack_public_path__ + "img/chinese_4.8172e790.png";